import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const itemPhotosListSlice = createSlice({
  name: "itemPhotosListSlice",
  initialState,
  //REDUCER
  reducers: {
    setItemPhotosList(state, action) {
      return {
        ...state,
        rows: action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    addItemPhotos(state, action) {
      return {
        ...state,
        rows: [...state.rows, action.payload],
      };
    },
    editItems(state, action) {
      return {
        ...state,
        rows: state.rows.map((row) =>
          row.id === action.payload.id ? action.payload : row
        ),
      };
    },
    deleteItemPhotos(state, action) {
      console.log("action.payload: ", action.payload);
      return {
        ...state,
        rows: state.rows.filter((row) => row !== action.payload),
      };
    },
  },
});

//ACTIONS
export const {
    setItemPhotosList,
    showLoading,
    hideLoading,
    addItemPhotos,
    editItems,
    deleteItemPhotos,
} = itemPhotosListSlice.actions;

export default itemPhotosListSlice.reducer;
